import {Injectable} from '@angular/core';
import {environment} from '../environments/environment.prod';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public authSource = new BehaviorSubject(null);
  public bimestreSource = new BehaviorSubject(null);
  base = environment.base;

  constructor(private http: HttpClient) {
  }

  login(credenciales: any) {
    return this.http.post(`${this.base}login`, credenciales)
      .pipe(map((data: any) => {
        if (data.success !== null) {
          const token = btoa(`Bearer ${data.success.token}`);
          localStorage.setItem('cealm-token', token);
        }
        return data;
      }));
  }

  signup(data: any) {
    return this.http.post(`${this.base}signup`, data);
  }

  getUser() {
    return this.http.post(`${this.base}get-user`, null);
  }

  getDocente() {
    return this.http.post(`${this.base}get-docente`, null);
  }

  getEstudiante() {
    return this.http.post(`${this.base}get-estudiante`, null);
  }

  setAuth(data: any) {
    this.authSource.next(data);
  }

  setBimestre(bimestreActual: any) {
    this.bimestreSource.next(bimestreActual);
  }

  contacto(data: any) {
    return this.http.post(`${this.base}contacto`, data);
  }

  changePassword(data: any) {
    return this.http.post(`${this.base}change-password`, data);
  }

  logout() {
    localStorage.removeItem('cealm-token');
    return new Observable((observer) => {
      observer.next(true);
      observer.complete();
    });
  }
}
